import { Outlet } from "react-router-dom";
import Footer from "../components/footer/Footer";

export default function Common() {
  return (
    <div>
      <Outlet />
      <Footer />
    </div>
  );
}
